<template>
    <div v-if="catalogStore.mobileSearch" class="pb-4">
        <Sorting />
    </div>

    <div v-else>
        <h1 v-if="catalog && catalog.teaser_title" v-html="catalog.teaser_title" class="text-left mb-2 mb-md-4 catalog-teaser-title"></h1>
        <CatalogTeaser :catalog="catalog" :expanded="catalogDescriptionExpanded" @description-expanded="() => catalogDescriptionExpanded = !catalogDescriptionExpanded"/>

        <CatalogOptions @export-pdf="emit('export-pdf')" @paginate="emit('search')"/>

        <CatalogProductsTable />

        <div class="row align-items-center" v-if="(catalogStore.products.length > 20 && catalogStore.getOption('view') === 'grid') || (catalogStore.products.length >= 9 && catalogStore.getOption('view') !== 'grid')">
            <div class="col-auto me-2 pt-2">
                <Pagination v-model="paginator.current_page" :value="paginator.current_page" :total="paginator.last_page" :scroll="true" @paginate="emit('search')" />
            </div>
        </div>

        <CatalogDescription :catalog="catalog"/>
    </div>
</template>

<script setup>
const CatalogTeaser = defineAsyncComponent(() => import("~/components/Catalog/CatalogTeaser.vue"));
const CatalogDescription = defineAsyncComponent(() => import("~/components/Catalog/CatalogDescription.vue"));
const CatalogOptions = defineAsyncComponent(() => import("~/components/Catalog/CatalogOptions.vue"));
const Sorting = defineAsyncComponent(() => import("~/components/Catalog/Sorting.vue"));
const CatalogProductsTable = defineAsyncComponent(() => import("~/components/Catalog/CatalogProductsTable.vue"));
const Pagination = defineAsyncComponent(() => import('~/components/Pagination.vue'));


const catalogStore = useCatalogStore();

const paginator = computed(() => catalogStore.paginator);

const spotRatesStore = useSpotRatesStore();

const catalogDescriptionExpanded = ref(false);

const catalog = computed(() => catalogStore.catalog);

const emit = defineEmits(['search', 'export-pdf']);

onMounted(() => spotRatesStore.addCallback('catalog-prices', (opts) => emit('search', opts)));
onUnmounted(() => spotRatesStore.removeCallback('catalog-prices'));

</script>
